import cn from 'classnames'
import { ClientOnly, getRouteApi } from '@tanstack/react-router'
import { ArcMarketCap, ArcMarketCapFallback } from '~/components/data-display/charts/ArcMarketCap'
import { HomepageHeaderTitle } from '~/components/pages/homepage/header/HeaderTitle'
import { HomepageHeaderMarketCap } from '~/components/pages/homepage/header/HeaderMarketCap'

export function HomepageHeader ()
{
    const { stats } = getRouteApi('/').useLoaderData()

    return (
        <div
            className={cn(
                'w-full',
                'flex flex-col items-stretch justify-between gap-0',
                'lg:flex-col lg:gap-3',
                'xl:grid xl:grid-cols-[max-content_1fr] xl:min-h-38 xl:gap-4',
                '@container/hpheader'
            )}
        >
            <HomepageHeaderTitle
                className={cn(
                    'px-4 py-3 border-x border-t border-accent/20 rounded-t-lg',
                    'md:rounded-lg md:border-0 md:border-accent/10', 'lg:pe-3 lg:ps-8'
                )}
            />

            <div
                className={cn(
                    'grow-1',
                    'flex flex-col gap-2 items-stretch justify-between',
                    'rounded-lg',
                    'md:px-4 md:py-3 md:gap-5 2xl:border border-accent/10',
                    'lg:w-full lg:grid lg:grid-cols-[1fr_max-content] lg:justify-stretch lg:gap-3 lg:ps-4 lg:pe-2 lg:py-3 lg:border lg:border-accent/10',
                )}
            >
                <div
                    className={cn(
                        'px-4 pt-3 min-h-[55vw] min-h-[55dvw] flex flex-col justify-end',
                        'rounded-b-lg border-x border-b border-accent/20',
                        'md:min-h-auto md:w-full md:h-40 md:border-0 md:px-0 md:max-w-110 md:mx-auto',
                        'lg:max-w-none lg:m-0 lg:p-0 lg:border lg:border-dashed lg:rounded-lg lg:px-2.5 lg:pt-1.5 lg:max-h-33',
                        'xl:max-h-none xl:h-full', '2xl:max-h-33',
                        'xl:-mb-3',
                    )}
                >
                    <ClientOnly fallback={<ArcMarketCapFallback total={stats.marketCap?.total || 0}
                                                                privacy={stats.marketCap?.privacy || 0} />}> <ArcMarketCap
                        total={stats.marketCap?.total || 0}
                        privacy={stats.marketCap?.privacy || 0}
                        className={cn('aspect-[10/6] md:aspect-auto md:h-full md:w-full')}
                    /> </ClientOnly>
                </div>

                <HomepageHeaderMarketCap className={cn('h-full')} />
            </div>
        </div>
    )
}